import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import moment from "moment";
import { Pagination } from 'react-bootstrap';

import customers1 from "../../../images/customers/1.jpg";
// import StarRating from "../Common/StarRating "
import Filter from './Filter';

import { getCustomersAction, updateCustomerAction } from '../../../store/actions/customer/CustomerActions';

function CustomerList() {
  const dispatch = useDispatch();
  const { customers, loading } = useSelector(state => state.customer);
	const totalPages = customers?.pages || 1;
  const customerRows = customers?.rows || [];
  const [openMenu, setOpenMenu] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterQuery, setFilterQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // "", "blocked", "unblocked"

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  const handleBlock = async (status, id) => {
    let alertText = ""
    if(status) {
      alertText="You want to unblock this customer"
    } else {
      alertText="You want to block this customer"
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      text: alertText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, do it!",
    });

    if (result.isConfirmed) {
      const payload = {
        isEnabled : status
      }
      console.log(payload)
      const response = await dispatch(updateCustomerAction(id, payload));
      if (response.data.success) {
        Swal.fire("Updated!", "The customer status has beed updated.", "success");
        await dispatch(getCustomersAction(currentPage, pageSize, "", filterQuery));
      }
    }
  }

  const buildSearchQuery = () => {
    const search = searchTerm ? searchTerm : '';
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (statusFilter === "blocked") params.append('filter_isEnabled', 'false');
    if (statusFilter === "unblocked") params.append('filter_isEnabled', 'true');
    const queryString = `${params.toString()}`;
    return queryString;
  };

  const onSubmit = async () => {
    const query = buildSearchQuery();
    setFilterQuery(query);
    setCurrentPage(1);
  }

  useEffect(() => {
    dispatch(getCustomersAction(currentPage, pageSize, "", filterQuery));
  }, [dispatch, currentPage, pageSize, filterQuery]);

  return (
    <>
      <div className="form-head page-titles d-flex  align-items-center">
        <div className="me-auto  d-lg-block">
          <h4 className="mb-1">Customer List</h4>
        </div>
      </div>
      <Filter 
        setOpenMenu={setOpenMenu} 
        openMenu={openMenu} 
        onSubmit={onSubmit}
        setSearchTerm={setSearchTerm}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              {loading ? (
                <div className="p-4">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="row border-bottom mx-0 pt-4 px-2 align-items-center">
                      <div className="col-xl-3 col-xxl-4 col-lg-6 col-sm-12 mb-sm-4 mb-3 align-items-center  media">
                        <div className="skeleton" style={{ width: 90, height: 90, background: '#eee', borderRadius: 8 }} />
                        <div className="media-body">
                          <div className="skeleton" style={{ width: 120, height: 24, background: '#eee', marginBottom: 8 }} />
                          <div className="skeleton" style={{ width: 80, height: 16, background: '#eee', marginBottom: 8 }} />
                        </div>
                      </div>
                      <div className="col-xl-2 col-xxl-3 col-lg-3 col-sm-4 mb-sm-4 col-6 mb-3">
                        <div className="skeleton" style={{ width: '100%', height: 16, background: '#eee', marginBottom: 8 }} />
                        <div className="skeleton" style={{ width: '100%', height: 16, background: '#eee', marginBottom: 8 }} />
                      </div>
                      <div className="col-xl-2 col-xxl-2 col-lg-3 col-sm-4 mb-sm-4 col-6 mb-3 text-lg-center">
                        <div className="skeleton" style={{ width: '60%', height: 16, background: '#eee', marginBottom: 8 }} />
                      </div>
                      <div className="col-xl-2 col-xxl-3 col-lg-6 col-sm-4 mb-sm-4 mb-3">
                        <div className="skeleton" style={{ width: '80%', height: 16, background: '#eee', marginBottom: 8 }} />
                      </div>
                      <div className="col-xl-3 col-xxl-4 col-lg-6 col-sm-6 mb-sm-4 mb-4 d-flex ">
                        <div className="skeleton" style={{ width: 100, height: 32, background: '#eee', borderRadius: 8 }} />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (!loading && customerRows.length === 0) ? (
                <div className="p-4 text-center text-muted">No data found</div>
              ) : (
                customerRows.map((item, ind) => (
                  <div
                    className="row border-bottom mx-0 pt-4 px-2 align-items-center"
                    key={item._id}
                  >
                    {/* ...existing code for customer row... */}
                    <div className="col-xl-3 col-xxl-4 col-lg-6 col-sm-12 mb-sm-4 mb-3 align-items-center  media">
                      <img
                        className="me-sm-4 me-3 img-fluid rounded"
                        width={90}
                        src={
                          item.profilePicture ? item.profilePicture : customers1
                        }
                        alt="DexignZone"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = customers1;
                        }}
                      />
                      <div className="media-body">
                        {/* <span className="text-primary d-block">#C01234</span> */}
                        <h4 className="mb-1">{item.name}</h4>
                        {/* <StarRating
                          average={item.ratings.average}
                          total={item.ratings.total}
                        /> */}
                        <span className="d-block mb-lg-0 mb-0">
                          Join on{" "}
                          {moment(item.createdAt).format("DD/MM/YYYY, hh:mm A")}
                        </span>
                        <span className="d-block mb-lg-0 mb-0">
                          Last Login{" "}
                          {moment(item.lastLogin).format("DD/MM/YYYY, hh:mm A")}
                        </span>
                      </div>
                    </div>
                    <div className="col-xl-2 col-xxl-3 col-lg-3 col-sm-4 mb-sm-4 col-6 mb-3">
                      <span className="text-black font-w600 d-block">
                        Number of adds : {item.adsPosted}
                      </span>
                      <span className="text-black font-w600 d-block">
                        Phone Verified : {item.isPhoneVerified ? "✔️" : "❌"}
                      </span>
                      <span className="text-black font-w600 d-block">
                        Email Verified : {item.isEmailVerified ? "✔️" : "❌"}
                      </span>
                    </div>
                    <div className="col-xl-2 col-xxl-2 col-lg-3 col-sm-4 mb-sm-4 col-6 mb-3 text-lg-center">
                      <small className="mb-2 d-block">Phone Number</small>
                      <span className="text-black font-w600">{item.phone}</span>
                    </div>
                    <div className="col-xl-2 col-xxl-3 col-lg-6 col-sm-4 mb-sm-4 mb-3">
                      <small className="mb-2 d-block">Email Address</small>
                      <span className="text-black font-w600">{item.email}</span>
                    </div>
                    <div className="col-xl-3 col-xxl-4 col-lg-6 col-sm-6 mb-sm-4 mb-4 d-flex ">
                      {item.isEnabled ? (
                        <button
                          className="btn btn-danger shadow sharp me-2"
                          onClick={() => handleBlock(false, item._id)}
                        >
                          Block User
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary shadow sharp me-2"
                          onClick={() => handleBlock(true, item._id)}
                        >
                          UnBlock User
                        </button>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div></div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-muted">
            Total Customers : {customers?.total || customerRows.length}
          </span>
          <Pagination className="pagination-gutter pagination-circle pagination mb-0">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            />
            {Array.from({ length: totalPages }, (_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === currentPage}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
            />
          </Pagination>
        </div>
      </div>
    </>
  );
}

export default CustomerList;
